import css from '../styles.css?url'

import {authQueryOptions} from '@/modules/auth/api'
import {rqContext} from '@/router'
import {dialog, drawer, Toaster} from '@cypro/ui/components'
import {TanStackDevtools} from '@tanstack/react-devtools'
import {ReactQueryDevtoolsPanel} from '@tanstack/react-query-devtools'
import {createRootRoute, HeadContent, Outlet, redirect, Scripts} from '@tanstack/react-router'
import {TanStackRouterDevtoolsPanel} from '@tanstack/react-router-devtools'

export const Route = createRootRoute({
  component: RootLayout,
  beforeLoad: async ({location}) => {
    const auth = await rqContext.queryClient.ensureQueryData(authQueryOptions)

    if (
      !auth?.user &&
      !location.pathname.startsWith('/auth/login') &&
      !location.pathname.startsWith('/auth/register')
    ) {
      throw redirect({to: '/auth/login', search: {location: location.pathname}})
    }

    if (auth?.user && auth?.session) {
      // if (!auth.session.account?.passwordSetupCompletedAt && !location.pathname.startsWith('/auth/password-setup')) {
      //   throw redirect({to: '/auth/password-setup'})
      // }
      if (location.pathname === '/') throw redirect({to: '/organisations'})
    }
  },
  head: () => {
    return {
      meta: [
        {charSet: 'utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {title: 'Cypro Admin'},
      ],
      links: [
        {rel: 'icon', href: '/favicon.png'},
        {rel: 'stylesheet', href: css},
      ],
    }
  },
})

function RootLayout() {
  return (
    <>
      <HeadContent />

      <Toaster />
      <dialog.Viewport />
      <drawer.Viewport />

      <Outlet />

      <Scripts />

      {import.meta.env.DEV && (
        <TanStackDevtools
          config={{position: 'bottom-right'}}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            {name: 'Tanstack Query', render: <ReactQueryDevtoolsPanel />},
          ]}
        />
      )}
    </>
  )
}
